import { render, staticRenderFns } from "./OrderReadyDialog.vue?vue&type=template&id=2d151d8c&"
import script from "./OrderReadyDialog.vue?vue&type=script&lang=js&"
export * from "./OrderReadyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports